import React from 'react';
interface CardProps {
  title?: string;
  children: React.ReactNode;
  className?: string;
  footer?: React.ReactNode;
}
const Card: React.FC<CardProps> = ({
  title,
  children,
  className = '',
  footer
}) => {
  return <div className={`bg-white dark:bg-slate-800/80 rounded-xl shadow-soft hover:shadow-md transition-shadow duration-300 border border-slate-100 dark:border-slate-700/50 overflow-hidden ${className}`} data-id="element-550">
      {title && <div className="px-6 py-4 border-b border-slate-100 dark:border-slate-700/50 bg-slate-50/50 dark:bg-slate-800/50" data-id="element-551">
          <h3 className="font-semibold text-slate-900 dark:text-white text-lg tracking-tight" data-id="element-552">
            {title}
          </h3>
        </div>}
      <div className="p-6" data-id="element-553">{children}</div>
      {footer && <div className="px-6 py-4 border-t border-slate-100 dark:border-slate-700/50 bg-slate-50/50 dark:bg-slate-800/50" data-id="element-554">
          {footer}
        </div>}
    </div>;
};
export default Card;